const Icon = require('../../utils/icon.js');
const { toHTML, client } = require('../../../src/utils/sanity/index.js');

const { projectId, dataset } = client.config();
const { buildSrc } = require('@sanity-image/url-builder');

module.exports = function ({
  title,
  subtitle,
  text,
  terms,
  image,
  signup_preset: preset,
  subscriptionId,
  allowAlreadySubscribed = false,
  blockHelpers,
  ...data
}) {
  return Promise.resolve(image).then(
    (image) => `<aside class="emailSignup"${imageHtml(image)} ${blockHelpers.id(
      data
    )}>
    
    <header>
      <h1>${title}</h1>
      ${subtitle ? `<p>${subtitle}</p>` : ``}
      ${text ? toHTML(text, data) : ``}
    </header>
      
    <form action="/_/subscribe/" x-data="emailSignup()" x-bind="form">
      <div x-cloak x-show="message" class="emailSignup__message" :class="success && 'success'">
        <span x-html="message"></span>
      </div>

      <div class="emailSignup__fields">
        <div>
          <label for="fname">First name</label>
          <input type="text" id="fname" name="fname" autocomplete="given-name" required>
        </div>

        <div>
          <label for="email">Email</label>
          <input type="email" id="email" name="email" required>
        </div>
      </div>

      ${Object.entries({ preset, subscriptionId, allowAlreadySubscribed })
        .map(([k, v]) =>
          v ? `<input type="hidden" name="${k}" value="${v}">` : ``
        )
        .join('')}

      <button class="button" type="submit">
        Sign up ${Icon('chevron')}
      </button>
    </form>

    ${terms ? `<footer>${toHTML(terms, data)}</footer>` : ``}
  </aside>`
  );
};

function imageHtml(image) {
  if (!image) return ``;

  try {
    const { _id: id, hotspot, crop } = image;

    let { x = 0.5, y = 0.5 } = getAdjustedHotspot(hotspot, crop);

    return ` style="background-image:url('${
      buildSrc({
        id,
        hotspot,
        crop,
        height: 1750,
        width: 1750,
        baseUrl: `https://cdn.sanity.io/images/${projectId}/${dataset}/`,
        queryParams: {
          q: 90
        }
      }).src
    }'); background-position:${x * 100}% ${y * 100}%;"`;
  } catch (error) {
    return ``;
  }
}

function getAdjustedHotspot(hotspot = {}, crop = {}) {
  try {
    return [
      ['x', crop.left, crop.right],
      ['y', crop.top, crop.bottom]
    ].reduce(
      (acc, [coord, cropA, cropB]) =>
        Object.assign(acc, {
          [coord]: calculate(hotspot[coord], cropA, cropB)
        }),
      {}
    );

    function calculate(coord = 0.5, cropA, cropB) {
      if (!(coord === 0.5 && cropA === 0 && cropB === 0)) {
        return (coord - cropA) / (1 - cropA - cropB);
      }

      return coord;
    }
  } catch (error) {
    return hotspot;
  }
}